import '../../homepage-source/bean-chat-speech.js'
import '../../homepage-source/bean-api-translation.js'
import '../../homepage-source/bean-character-fit.js'
import '../../homepage-source/bean-agent-media-variant.js'

const AGENT_ASSET = new URL('../assets/products/2智体/rabbit_1_245.webp', document.baseURI).href
const AI_ENDPOINT = 'https://tossp.yoooooo.com/index.php/index/center_ai/query_private'
const FALLBACK_AGENT = {
  id: 'universe-agent-fallback',
  key: 'universe-agent-fallback',
  name: '智体助手',
  role: '目标与方案智体',
  color: '#67ecff',
  image: AGENT_ASSET
}

function installFourFlow (frame) {
  frame.classList.add('chat-static-border')
  const edge = document.createElement('span')
  edge.className = 'chat-static-border-edge'
  edge.setAttribute('aria-hidden', 'true')
  frame.prepend(edge)
  return { start () {}, stop () {}, destroy () { edge.remove(); frame.classList.remove('chat-static-border') } }
}

function readJsonResponse (response) {
  return response.text().then(body => {
    let payload = {}
    try {
      payload = body ? JSON.parse(body) : {}
    } catch (_) {
      throw new Error('服务返回了无法识别的数据')
    }
    const proxyError = response.headers.get('x-universe-bean-proxy-error')
    const upstreamStatus = Number(response.headers.get('x-universe-bean-upstream-status'))
    if (!response.ok || proxyError || upstreamStatus >= 400) {
      throw new Error(payload.message || payload.msg || ('服务请求失败（' + response.status + '）'))
    }
    return payload
  })
}

function findAnswer (value, depth) {
  const currentDepth = depth || 0
  if (!value || currentDepth > 5) return ''
  if (typeof value === 'string') return currentDepth === 0 ? value.trim() : ''
  if (Array.isArray(value)) {
    for (let index = 0; index < value.length; index += 1) {
      const answer = findAnswer(value[index], currentDepth + 1)
      if (answer) return answer
    }
    return ''
  }
  if (typeof value !== 'object') return ''
  const answerKeys = ['answer', 'reply', 'content', 'message']
  for (let index = 0; index < answerKeys.length; index += 1) {
    const answer = value[answerKeys[index]]
    if (typeof answer === 'string' && answer.trim()) return answer.trim()
  }
  const nestedKeys = ['data', 'result', 'payload']
  for (let index = 0; index < nestedKeys.length; index += 1) {
    const answer = findAnswer(value[nestedKeys[index]], currentDepth + 1)
    if (answer) return answer
  }
  return ''
}

function requestUniverseAnswer (query, signal, onCapabilities, language = window.BeanApiTranslation.current()) {
  const download = window.WebsiteModuleRoute && window.WebsiteModuleRoute.downloadAnswer(query, language)
  if (download) return Promise.resolve(download)
  const body = new FormData()
  body.append('query', query)
  body.append('language', language)
    try { const style = sessionStorage.getItem('capability-assistant-style'); if (style) body.append('response_style', style); } catch (_) {}
  return fetch(AI_ENDPOINT, {
    method: 'POST',
    body,
    headers: { Accept: 'application/json' },
    signal
  }).then(readJsonResponse).then(payload => {
    const capabilities = window.WebsiteCapabilityCards ? window.WebsiteCapabilityCards.extract(payload) : []
    if (onCapabilities) onCapabilities(capabilities)
    const answer = findAnswer(payload) || (capabilities.length ? '为您找到以下网站功能。' : '')
    if (!answer) throw new Error('AI 服务未返回 answer')
    return {text: answer, translation: window.BeanApiTranslation.read(payload, language)}
  })
}

export default function installDownloadUniverseBeanChat (root) {
  const scope = root || document
  const trigger = scope.querySelector('.universe-bean-chat-trigger')
  const overlay = scope.querySelector('#bean-chat-overlay')
  const resident = overlay && overlay.dataset.beanResident === 'true'
  const backdrop = scope.querySelector('#bean-chat-backdrop')
  const stage = scope.querySelector('.experience-stage')
  const stageFrame = scope.querySelector('iframe.homepage-universe-stage-frame')
  const channelConsole = scope.querySelector('.channel-console')
  const panel = overlay && overlay.querySelector('.bean-chat-panel')
  const closeButton = overlay && overlay.querySelector('.bean-chat-close')
  const expandButton = overlay && overlay.querySelector('.bean-chat-expand')
  const muteButton = overlay && overlay.querySelector('.bean-chat-mute')
  const backgroundButton = overlay && overlay.querySelector('.bean-chat-background-toggle')
  const agentButton = overlay && overlay.querySelector('.bean-chat-agent-toggle')
  const clearButton = overlay && overlay.querySelector('.bean-chat-clear')
  const log = overlay && overlay.querySelector('.bean-chat-log')
  const thread = overlay && overlay.querySelector('.bean-chat-thread')
  const form = overlay && overlay.querySelector('.bean-chat-form')
  const input = overlay && overlay.querySelector('.bean-chat-input')
  const sendButton = form && form.querySelector('.bean-chat-send')
  const introMessage = thread && thread.querySelector('.bean-chat-intro-message')
  const introSource = introMessage && introMessage.querySelector('p')
  const defaultIntroParagraph = introSource && (window.HomepageLanguage ? window.HomepageLanguage.cloneSource(introSource) : introSource.cloneNode(true))
  if (!trigger || !overlay || !backdrop || !stage || !panel || !closeButton || !expandButton || !muteButton || !backgroundButton || !agentButton || !clearButton || !log || !thread || !form || !input || !sendButton) return function () {}

  let chatDisposed = false
  const removers = []
  removers.push(window.bindUniverseBeanActionState(overlay))
  removers.push(window.UniverseBeanCharacterFit.install(overlay))
  const listen = (target, type, handler, options) => {
    target.addEventListener(type, handler, options)
    removers.push(() => target.removeEventListener(type, handler, options))
  }
  const fourFlow = installFourFlow(overlay, true)
  let detailFlow = null
  let closeTimer = 0
  let focusTimer = 0
  let placementFrame = 0
  let capabilityLastQuery = '';
  let activeRequestController = null
  let requestSequence = 0
  let activeLanguage = 'zh'
  let previouslyFocused = null
  let placementResizeObserver = null
  let activeAnchor = null
  let activeAgent = FALLBACK_AGENT
  // This Vue entry is visible when mounted, including the application-center iframe.
  // Only the sidebar's separate host protocol starts its resident chat collapsed.
  if (resident) overlay.dataset.beanHostOpen = 'true'

  const syncExpandedButton = expanded => {
    expandButton.setAttribute('aria-pressed', String(expanded))
    expandButton.setAttribute('aria-label', expanded ? '还原宇宙豆对话' : '放大宇宙豆对话')
    expandButton.title = expanded ? '还原宇宙豆对话' : '放大宇宙豆对话'
  }

  const setExpanded = expanded => {
    const nextExpanded = Boolean(expanded)
    overlay.classList.toggle('is-expanded', nextExpanded)
    overlay.setAttribute('aria-modal', String(!resident || nextExpanded))
    syncExpandedButton(nextExpanded)
    updatePlacement()
    if (window.parent !== window) {
      window.parent.postMessage({ type: 'universe-download-center:chat-expanded', expanded: nextExpanded }, location.origin)
    }
  }

  listen(window, 'message', event => {
    if (event.origin === location.origin && event.source === window.parent &&
        event.data && event.data.type === 'universe-download-center:restore-chat') setExpanded(false)
  })

  // Synchronize identity before the speech controller handles the same event.
  listen(window, 'universe-agent-changed', () => {
    if (!chatDisposed) activeAgent = window.__activeUniverseAgent || FALLBACK_AGENT
  })

  const speech = window.UniverseBeanSpeech.create({
    overlay, button: muteButton,
    getAgent: () => activeAgent,
    getIntro: () => {
      const paragraph = thread.querySelector('.bean-chat-intro-message p');
      return paragraph ? paragraph.textContent : '';
    }
  });
  const setMuted = muted => speech.setMuted(muted);

  const initializeBackgroundButton = () => {
    overlay.classList.remove('is-background-disabled')
    backgroundButton.removeAttribute('aria-pressed')
    backgroundButton.setAttribute('aria-label', '随机更换背景')
    backgroundButton.title = '随机更换背景'
  }

  // Use the same local-first media controller as the homepage and sidebar.
  // Keep this component's active identity in sync for speech and submitted questions.
  const selectRandomAgent = () => {
    if (chatDisposed) return activeAgent
    return window.selectRandomUniverseAgent()
  }
  const selectRandomBackground = () => {
    if (chatDisposed) return null
    return window.selectRandomUniverseBeanBackground()
  }
  const suspendMedia = () => window.suspendUniverseBeanMedia()

  const syncPlacement = () => {
    const stageRect = stage.getBoundingClientRect()
    const visibleBottom = Math.min(window.innerHeight, stageRect.bottom)
    const consoleRect = channelConsole && channelConsole.getBoundingClientRect()
    const lowerAreaTop = consoleRect && consoleRect.height > 0
      ? Math.max(stageRect.top, consoleRect.bottom)
      : stageRect.top
    const visibleTop = Math.min(visibleBottom, Math.max(0, lowerAreaTop))
    const availableHeight = Math.max(0, visibleBottom - visibleTop)
    if (resident) {
      // Keep the complete square background visible inside the available stage.
      const panelSize = Math.min(stageRect.width, availableHeight)
      const panelLeft = stageRect.left + (stageRect.width - panelSize) / 2
      overlay.style.setProperty('--bean-chat-left', panelLeft + 'px')
      overlay.style.setProperty('--bean-chat-top', visibleTop + 'px')
      overlay.style.setProperty('--bean-chat-width', panelSize + 'px')
      overlay.style.setProperty('--bean-chat-height', panelSize + 'px')
      return
    }
    overlay.style.setProperty('--bean-chat-left', stageRect.left + 'px')
    overlay.style.setProperty('--bean-chat-top', visibleTop + 'px')
    overlay.style.setProperty('--bean-chat-width', stageRect.width + 'px')
    overlay.style.setProperty('--bean-chat-height', availableHeight + 'px')
    const originX = activeAnchor
      ? Math.min(Math.max(activeAnchor.x - stageRect.left, 0), stageRect.width)
      : Math.max(0, stageRect.width - 44)
    const originY = activeAnchor
      ? Math.min(Math.max(activeAnchor.y - visibleTop, 0), availableHeight)
      : Math.max(0, availableHeight - 40)
    overlay.style.setProperty('--bean-chat-origin-x', originX + 'px')
    overlay.style.setProperty('--bean-chat-origin-y', originY + 'px')
  }

  const updatePlacement = () => {
    syncPlacement()
    cancelAnimationFrame(placementFrame)
    cancelAnimationFrame(scrollFrame)
    placementFrame = requestAnimationFrame(syncPlacement)
  }

  let followLatest = true;
  let scrollFrame = 0;
  const newContentButton = document.createElement('button');
  newContentButton.type = 'button';
  newContentButton.className = 'chat-new-content';
  newContentButton.textContent = '有新内容';
  newContentButton.hidden = true;
  panel.appendChild(newContentButton);
  const listenScroll = (target, type, handler, options) => listen(target, type, handler, options);
  const trackScroll = () => {
    followLatest = thread.scrollHeight - thread.scrollTop - thread.clientHeight < 64;
    if (followLatest) newContentButton.hidden = true;
  };
  listenScroll(thread, 'scroll', trackScroll, { passive: true });
  const scrollToEnd = () => {
    if (!followLatest) { newContentButton.hidden = false; return; }
    newContentButton.hidden = true;
    if (scrollFrame) return;
    scrollFrame = window.requestAnimationFrame(() => {
      scrollFrame = 0;
      if (followLatest) thread.scrollTop = thread.scrollHeight;
    });
  };
  listenScroll(newContentButton, 'click', () => { followLatest = true; scrollToEnd(); });

  const createMessage = (text, type) => {
    const row = document.createElement('div')
    row.className = 'bean-chat-row ' + (type === 'user' ? 'is-user' : 'is-assistant')
    if (type !== 'user') {
      const avatar = document.createElement('img')
      avatar.className = 'bean-chat-row-avatar'
      avatar.src = activeAgent.image
      avatar.alt = activeAgent.name
      row.appendChild(avatar)
    }
    const bubble = document.createElement('div')
    bubble.className = 'bean-chat-bubble'
    bubble.textContent = text
    row.appendChild(bubble)
    thread.appendChild(row)
    scrollToEnd()
    return { row, bubble }
  }

  const productDetailCard = document.createElement('section')
  productDetailCard.className = 'bean-chat-product-card'
  productDetailCard.hidden = true
  productDetailCard.setAttribute('role', 'dialog')
  productDetailCard.setAttribute('aria-modal', 'true')
  productDetailCard.setAttribute('aria-hidden', 'true')
  productDetailCard.innerHTML = `
    <div class="bean-chat-product-frame">
      <button class="bean-chat-product-close" type="button" aria-label="关闭宇宙生成指引" data-hover-click="false"><span aria-hidden="true">×</span></button>
      <header class="bean-chat-product-header">
        <img class="bean-chat-product-orb" src="" alt="">
        <h3 class="bean-chat-product-title"></h3>
        <span class="bean-chat-product-subtitle">宇宙核心生成指引</span>
      </header>
      <div class="bean-chat-product-layout">
        <section class="bean-chat-product-generation" aria-label="生成方式">
          <h4>生成方式：下载【宇宙之幂】</h4>
          <p>任选入口进入，或使用应用中心二维码获取。</p>
        </section>
        <aside class="bean-chat-product-download">
          <div class="bean-chat-product-access" data-dual-flow>
            <div class="bean-chat-product-access-links">
              <a class="bean-chat-product-link" href="https://universe.top/" target="_blank" rel="noopener noreferrer" data-hover-click="false">
                <span><strong>进入宇宙之幂官网</strong><small>获取【宇宙之幂】</small></span>
                <i class="bean-chat-link-hand" aria-hidden="true"><span><img src="/hand-pointer-cursor.svg" alt="" draggable="false"></span><u></u></i>
              </a>
              <a class="bean-chat-product-link" href="/download/" target="_blank" rel="noopener noreferrer" data-hover-click="false">
                <span><strong>进入宇宙之幂应用中心</strong><small>获取【宇宙之幂】</small></span>
                <i class="bean-chat-link-hand" aria-hidden="true"><span><img src="/hand-pointer-cursor.svg" alt="" draggable="false"></span><u></u></i>
              </a>
            </div>
            <div class="bean-chat-product-qr">
              <img src="/static/download-single-sphere/universe-power-qr-20260819.png" alt="宇宙之幂下载二维码">
              <b>扫码获取</b><small>【宇宙之幂】</small>
              <i class="bean-chat-qr-hand" aria-hidden="true"><span><img src="/hand-pointer-cursor.svg" alt="" draggable="false"></span><u></u></i>
            </div>
          </div>
        </aside>
        <section class="bean-chat-product-methods" aria-label="生成步骤">
          <div class="bean-chat-product-method"><span class="bean-chat-product-method-index">01</span><div><h4>方式一：宇宙起源模式</h4><p>点击屏幕唤出宇宙核心—注入形态、意识、行为、力量，可选择生存的宇宙。</p></div></div>
          <div class="bean-chat-product-method"><span class="bean-chat-product-method-index">02</span><div><h4>方式二：宇宙运行模式</h4><p>选择宇宙—点击屏幕—注入形态—选择产品—注入形态、意识、行为、力量。</p></div></div>
          <p class="bean-chat-product-note">注：产品可随意调取宇宙核心进行编辑。</p>
        </section>
      </div>
    </div>`
  overlay.appendChild(productDetailCard)

  const productDetailClose = productDetailCard.querySelector('.bean-chat-product-close')
  const productDetailImage = productDetailCard.querySelector('.bean-chat-product-orb')
  const productDetailTitle = productDetailCard.querySelector('.bean-chat-product-title')
  let productDetailReturnFocus = null

  const closeRecommendationDetail = (restoreFocus = true) => {
    if (productDetailCard.hidden) return false
    const returnFocus = productDetailReturnFocus
    productDetailCard.hidden = true
    productDetailCard.setAttribute('aria-hidden', 'true')
    overlay.classList.remove('has-product-card')
    panel.inert = false
    panel.removeAttribute('aria-hidden')
    productDetailReturnFocus = null
    if (detailFlow) detailFlow.stop()
    if (restoreFocus && returnFocus && returnFocus.isConnected) returnFocus.focus({ preventScroll: true })
    return true
  }

  const restoreDefaultIntro = () => {
    if (overlay.dataset.beanConversation !== 'recommendation' || !defaultIntroParagraph || !introMessage) return
    introMessage.querySelector('p').replaceWith(defaultIntroParagraph.cloneNode(true))
    delete overlay.dataset.beanConversation
  }

  const openRecommendationDetail = () => {
    speech.stop()
    requestSequence += 1
    if (activeRequestController) activeRequestController.abort()
    activeRequestController = null
    setSubmitting(false)
    closeRecommendationDetail(false)
    Array.from(thread.children).forEach(node => {
      if (node.classList.contains('bean-chat-row')) node.remove()
    })

    const introParagraph = introMessage && introMessage.querySelector('p')
    if (introParagraph) {
      const welcome = document.createElement('span')
      welcome.className = 'bean-chat-answer-intro-welcome'
      welcome.textContent = '欢迎加入宇宙之幂。'
      introParagraph.replaceChildren(
        document.createTextNode('在宇宙之幂中，您可通过“仓库” “市场” “自制” “描述”方式，拥有无数的宇宙空间，并产生无数的宇宙应用。'),
        welcome
      )
    }

    overlay.dataset.beanConversation = 'recommendation'
    input.value = ''
    selectRandomAgent()
    selectRandomBackground()
    requestAnimationFrame(() => {
      thread.scrollTop = 0
      input.focus({ preventScroll: true })
    })
  }

  const prepareApiResponse = message => {
    message.bubble.className = 'bean-chat-bubble bean-chat-api-response';
    message.bubble.replaceChildren();
    const answerCopy = document.createElement('div');
    answerCopy.className = 'bean-chat-copy-block';
    const answerSlot = document.createElement('p');
    answerSlot.className = 'bean-chat-answer bean-chat-stage-paragraph';
    answerSlot.textContent = '正在思考……';
    answerCopy.appendChild(answerSlot);
    message.bubble.appendChild(answerCopy);
    return { ...message, answerSlot };
  };

  const renderAnswerResult = (message, result) => {
    message.answerSlot.textContent = result.status === 'fulfilled'
      ? result.value.text
      : 'AI 问答服务暂时无法连接，请稍后再试'
    message.answerSlot.classList.toggle('is-error', result.status === 'rejected')
    if (result.status === 'fulfilled') window.BeanApiTranslation.render(message.answerSlot, result.value.translation)
    scrollToEnd()
  }

  const setSubmitting = submitting => {
    sendButton.disabled = submitting
    sendButton.textContent = submitting ? '处理中' : '发送'
    input.setAttribute('aria-busy', submitting ? 'true' : 'false')
  }

  const clearConversation = () => {
    if (window.WebsiteCapabilityCards && window.WebsiteCapabilityCards.cancelWithin) window.WebsiteCapabilityCards.cancelWithin(overlay);
    newContentButton.hidden = true;
    followLatest = true;
    capabilityLastQuery = '';
    speech.stop()
    requestSequence += 1
    if (activeRequestController) activeRequestController.abort()
    activeRequestController = null
    setSubmitting(false)
    closeRecommendationDetail(false)
    Array.from(thread.children).forEach(node => {
      if (node.matches('.bean-chat-row:not([data-initial-push]),.agent-account-message,.creation-download-content')) node.remove()
    })
    // Keep opening modules in place, including asynchronously mounted downloads.
    delete overlay.dataset.beanConversation
    if (window.speechSynthesis) window.speechSynthesis.cancel()
    input.value = ''
    thread.scrollTop = 0
    input.focus({ preventScroll: true })
  }

  const cancelActiveTurn = event => {
    if (window.WebsiteCapabilityCards && window.WebsiteCapabilityCards.cancelWithin) window.WebsiteCapabilityCards.cancelWithin(overlay);
    // Agent changes already restart the intro in the shared speech controller.
    // This later listener cancels the previous answer, not the new greeting.
    if (event.type === 'pagehide') speech.stop();
    requestSequence += 1;
    if (activeRequestController) activeRequestController.abort();
    activeRequestController = null;
    setSubmitting(false);
  };
  ['universe-agent-changed', 'pagehide'].forEach(type => listen(window, type, cancelActiveTurn));

  const submitUniverseQuery = async rawValue => {
    const value = String(rawValue || '').trim();
    if (!value) return;
    capabilityLastQuery = value;
    speech.stop();
    const answerSpeechId = speech.sequence();
    const answerAgent = activeAgent;
    if (activeRequestController) activeRequestController.abort();
    const controller = new AbortController();
    const language = window.BeanApiTranslation.current();
    activeLanguage = language;
    const sequence = ++requestSequence;
    activeRequestController = controller;
    const analyticsTurn = window.SiteAnalytics ? window.SiteAnalytics.startTurn('3') : null;
    if (analyticsTurn && analyticsTurn.recordMessage) analyticsTurn.recordMessage('user', value);
    followLatest = true;
    createMessage(value, 'user');
    input.value = '';
    const responseMessage = prepareApiResponse(createMessage('正在思考……', 'assistant'));
    responseMessage.row.classList.add('is-pending');
    setSubmitting(true);
    let answerComplete = false;

    const isCurrent = () => sequence === requestSequence && !controller.signal.aborted && language === window.BeanApiTranslation.current();
    const release = () => {
      if (activeRequestController === controller) activeRequestController = null;
    };
    const timer = window.setTimeout(() => {
      answerComplete = true;
      responseMessage.row.classList.remove('is-pending');
      responseMessage.answerSlot.textContent = '回答超时，请重试。';
      responseMessage.answerSlot.classList.add('is-error');
      if (analyticsTurn) analyticsTurn.finish('failed');
      setSubmitting(false);
      controller.abort();
      release();
    }, 95000);
    controller.signal.addEventListener('abort', () => {
      window.clearTimeout(timer);
      if (!answerComplete) {
        responseMessage.row.remove();
        if (analyticsTurn) analyticsTurn.finish('cancelled');
      }
      if (activeRequestController === controller) setSubmitting(false);
    }, { once: true });

    try {
      const answer = await window.WebsiteModuleRoute.dispatch(value, {signal: controller.signal});
      if (!isCurrent()) return;
      renderAnswerResult(responseMessage, { status: 'fulfilled', value: answer });
      await window.WebsiteModuleRoute.renderDispatch(responseMessage.bubble, answer, isCurrent);
      if (!isCurrent()) return;
      followLatest = false;
      requestAnimationFrame(() => requestAnimationFrame(() => {
        if (isCurrent()) thread.scrollTop += responseMessage.row.getBoundingClientRect().top - thread.getBoundingClientRect().top;
      }));
      if (analyticsTurn && analyticsTurn.recordMessage) analyticsTurn.recordMessage('assistant', answer.text);
      if (analyticsTurn) analyticsTurn.finish('success');
      if (answerSpeechId === speech.sequence() && answerAgent && answerAgent.key === (activeAgent || {}).key) {
        speech.speak(answer.text, answerAgent, false, answer.translation.language);
      }
    } catch (error) {
      if (isCurrent()) {
        renderAnswerResult(responseMessage, { status: 'rejected', reason: error });
        if (analyticsTurn) analyticsTurn.finish('failed');
      }
    } finally {
      window.clearTimeout(timer);
      answerComplete = true;
      responseMessage.row.classList.remove('is-pending');
      if (activeRequestController === controller) setSubmitting(false);
      release();
    }
  };

  const focusableElements = container => Array.prototype.slice.call(container.querySelectorAll(
    'a[href],button:not([disabled]),input:not([disabled]),textarea:not([disabled]),' +
    'select:not([disabled]),[tabindex]:not([tabindex="-1"])'
  )).filter(element => !element.hidden && element.getAttribute('aria-hidden') !== 'true' && element.getClientRects().length > 0)

  const open = (event, anchor, selection) => {
    if (event) event.stopPropagation()
    if (resident && overlay.classList.contains('is-open') && overlay.dataset.beanHostOpen !== 'false') return
    if (resident) overlay.dataset.beanHostOpen = 'true'
    activeAnchor = anchor && Number.isFinite(anchor.x) && Number.isFinite(anchor.y)
      ? { x: anchor.x, y: anchor.y }
      : null
    if (!resident && window.SiteAnalytics) window.SiteAnalytics.track('feature_trigger', { task_id: '3', feature: 'bean_chat', method: 'open' })
    clearTimeout(closeTimer)
    clearTimeout(focusTimer)
    previouslyFocused = document.activeElement
    restoreDefaultIntro()
    const selectedKind = window.selectUniverseBeanSubject && window.selectUniverseBeanSubject(selection)
    if (selectedKind !== 'agent') selectRandomAgent()
    if (selectedKind !== 'background') selectRandomBackground()
    overlay.hidden = false
    updatePlacement()
    fourFlow.start()
    overlay.setAttribute('aria-hidden', 'false')
    speech.unlock()
    backdrop.setAttribute('aria-hidden', String(resident))
    trigger.setAttribute('aria-expanded', 'true')
    document.body.classList.add('bean-chat-open')
    const openingSequence = speech.sequence()
    requestAnimationFrame(() => {
      syncPlacement()
      if (!overlay.classList.contains('is-open') && window.SiteAnalytics && window.SiteAnalytics.openChat) window.SiteAnalytics.openChat((window.__activeUniverseAgent || {}).key || 'universe_bean')
      overlay.classList.add('is-open')
      if (openingSequence === speech.sequence()) speech.open()
      if (!resident) backdrop.classList.add('is-open')
      thread.scrollTop = 0
    })
    if (!resident) focusTimer = window.setTimeout(() => input.focus({ preventScroll: true }), 220)
  }

  const close = () => {
    if (window.WebsiteCapabilityCards && window.WebsiteCapabilityCards.cancelWithin) window.WebsiteCapabilityCards.cancelWithin(overlay);
    newContentButton.hidden = true;
    if (activeRequestController) activeRequestController.abort();
    activeRequestController = null;
    window.cancelAnimationFrame(scrollFrame);
    scrollFrame = 0;
    setSubmitting(false);
    speech.stop()
    clearTimeout(focusTimer)
    closeRecommendationDetail(false)
    setExpanded(false)
    if (resident) {
      overlay.dataset.beanHostOpen = 'false'
      if (window.parent !== window) {
        window.parent.postMessage({ type: 'universe-download-center:close' }, location.origin)
      } else {
        window.location.assign('/')
      }
      return
    }
    overlay.classList.remove('is-open')
    backdrop.classList.remove('is-open')
    overlay.setAttribute('aria-hidden', 'true')
    backdrop.setAttribute('aria-hidden', 'true')
    trigger.setAttribute('aria-expanded', 'false')
    document.body.classList.remove('bean-chat-open')
    clearTimeout(closeTimer)
    closeTimer = window.setTimeout(() => {
      overlay.hidden = true
      suspendMedia()
      fourFlow.stop()
      const restoreTarget = previouslyFocused && document.documentElement.contains(previouslyFocused) ? previouslyFocused : trigger
      if (restoreTarget && typeof restoreTarget.focus === 'function') restoreTarget.focus({ preventScroll: true })
      previouslyFocused = null
    }, 470)
  }

  const handleKeydown = event => {
    if (!overlay.classList.contains('is-open')) return
    if (event.key === 'Escape') {
      event.preventDefault()
      if (closeRecommendationDetail()) return
      if (overlay.classList.contains('is-expanded')) {
        setExpanded(false)
        expandButton.focus({ preventScroll: true })
        return
      }
      close()
      return
    }
    if (event.key !== 'Tab') return
    if (resident && !overlay.classList.contains('is-expanded') && productDetailCard.hidden) return
    const focusScope = productDetailCard.hidden ? overlay : productDetailCard
    const focusable = focusableElements(focusScope)
    if (!focusable.length) return
    const first = focusable[0]
    const last = focusable[focusable.length - 1]
    if (event.shiftKey && (document.activeElement === first || !focusScope.contains(document.activeElement))) {
      event.preventDefault()
      last.focus({ preventScroll: true })
    } else if (!event.shiftKey && (document.activeElement === last || !focusScope.contains(document.activeElement))) {
      event.preventDefault()
      first.focus({ preventScroll: true })
    }
  }

  let composing = false;
  listen(input, 'compositionstart', () => { composing = true; });
  listen(input, 'compositionend', () => { composing = false; });
  const handleSubmit = event => {
    event.preventDefault();
    if (composing || event.isComposing) return
    submitUniverseQuery(input.value)
  }

  const handleStageMessage = event => {
    const message = event.data
    const detail = message && message.detail ? message.detail : {}
    const viewportWidth = Number(detail.viewportWidth)
    const viewportHeight = Number(detail.viewportHeight)
    if (
      !stageFrame ||
      event.origin !== window.location.origin ||
      event.source !== stageFrame.contentWindow ||
      !message ||
      message.type !== 'universe-bean:open' ||
      detail.source !== 'secondary-sphere' ||
      !Number.isFinite(detail.x) ||
      !Number.isFinite(detail.y) ||
      !Number.isFinite(viewportWidth) ||
      !Number.isFinite(viewportHeight) ||
      viewportWidth <= 0 ||
      viewportHeight <= 0
    ) return
    const frameRect = stageFrame.getBoundingClientRect()
    open(null, {
      x: frameRect.left + detail.x * frameRect.width / viewportWidth,
      y: frameRect.top + detail.y * frameRect.height / viewportHeight
    }, detail.selection)
  }

  listen(trigger, 'click', open)
  listen(closeButton, 'click', close)
  listen(muteButton, 'click', () => setMuted(muteButton.getAttribute('aria-pressed') !== 'true'))
  listen(backgroundButton, 'click', selectRandomBackground)
  listen(agentButton, 'click', selectRandomAgent)
  listen(expandButton, 'click', () => setExpanded(!overlay.classList.contains('is-expanded')))
  listen(clearButton, 'click', clearConversation)
  listen(productDetailClose, 'click', () => closeRecommendationDetail())
  listen(backdrop, 'click', close)
  listen(form, 'submit', handleSubmit)
  ;['homepage:language-change', 'dialog:language-change', 'universe-bean-language-change'].forEach(type => {
    listen(window, type, () => {
      if (window.WebsiteCapabilityCards && window.WebsiteCapabilityCards.cancelWithin) window.WebsiteCapabilityCards.cancelWithin(overlay);
      if (!activeRequestController || window.BeanApiTranslation.current() === activeLanguage) return
      speech.stop(); requestSequence += 1
      activeRequestController.abort(); activeRequestController = null
      setSubmitting(false)
    })
  })
  listen(document, 'keydown', handleKeydown)
  listen(window, 'message', handleStageMessage)
  listen(window, 'resize', updatePlacement, { passive: true })
  listen(window, 'scroll', updatePlacement, { passive: true, capture: true })
  listen(window, 'orientationchange', updatePlacement, { passive: true })
  if ('ResizeObserver' in window) {
    placementResizeObserver = new window.ResizeObserver(updatePlacement)
    placementResizeObserver.observe(stage)
    if (channelConsole) placementResizeObserver.observe(channelConsole)
  }
  speech.syncMuted()
  initializeBackgroundButton()
  syncExpandedButton(false)
  window.CapabilityChatControl = {
    submit: async (query) => { capabilityLastQuery=query;await submitUniverseQuery(query) },
    retry: async () => {if(!capabilityLastQuery)return {status:'unavailable',message:'当前没有可重试的问题。'};await submitUniverseQuery(capabilityLastQuery);return {status:'success',message:'已重新请求回答。'}},
    cancel: () => {const pending=!!activeRequestController;requestSequence+=1;if(activeRequestController)activeRequestController.abort();activeRequestController=null;setSubmitting(false);return {status:pending?'success':'no_op',message:pending?'已停止当前回答。':'当前没有待完成的回答。'}},
    clear:()=>{capabilityLastQuery='';clearConversation()},open:()=>open(),close,expand:setExpanded,mute:setMuted,
    welcome:()=>{open();createMessage((window.OpeningCopy && window.OpeningCopy.bean)||'欢迎使用宇宙之幂。');return {status:'success',message:'已显示固定开场介绍。'}}
  }
  updatePlacement()
  if (resident) {
    open()
    let activeCategory = document.body.dataset.hierarchyFocus || ''
    const syncCategory = () => {
      const category = document.body.dataset.hierarchyFocus || ''
      const changed = category !== activeCategory
      activeCategory = category
      const wasVisible = !overlay.hidden
      overlay.hidden = false
      overlay.setAttribute('aria-hidden', 'false')
      if (changed) {
        closeRecommendationDetail(false)
        if (overlay.classList.contains('is-expanded')) setExpanded(false)
      }
      updatePlacement()
      if (changed) {
        selectRandomBackground()
        selectRandomAgent()
      }
      if (!wasVisible) speech.open()
    }
    const categoryObserver = new MutationObserver(syncCategory)
    categoryObserver.observe(document.body, { attributes: true, attributeFilter: ['data-hierarchy-focus'] })
    removers.push(() => categoryObserver.disconnect())
    syncCategory()
  }

  return function removeDownloadUniverseBeanChat () {
    chatDisposed = true
    suspendMedia()
    speech.destroy()
    clearTimeout(closeTimer)
    clearTimeout(focusTimer)
    cancelAnimationFrame(placementFrame)
    cancelAnimationFrame(scrollFrame)
    if (activeRequestController) activeRequestController.abort()
    if (placementResizeObserver) placementResizeObserver.disconnect()
    removers.splice(0).forEach(remove => remove())
    if (detailFlow) detailFlow.destroy()
    fourFlow.destroy()
    newContentButton.remove()
    productDetailCard.remove()
    overlay.classList.remove('is-open', 'has-product-card', 'is-expanded', 'is-background-disabled')
    backdrop.classList.remove('is-open')
    overlay.hidden = true
    overlay.setAttribute('aria-hidden', 'true')
    backdrop.setAttribute('aria-hidden', 'true')
    trigger.setAttribute('aria-expanded', 'false')
    document.body.classList.remove('bean-chat-open')
  }
}



// WEBPACK FOOTER //
// ./src/download/download-universe-bean-chat-current.js